import { useEffect } from "react";

interface UseImageKeyboardOptions {
  open: boolean;
  onClose: () => void;
  canNavigatePrev: boolean;
  canNavigateNext: boolean;
  onNavigate: (direction: "prev" | "next") => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  onFullscreen: () => void;
}

export function useImageKeyboard({
  open,
  onClose,
  canNavigatePrev,
  canNavigateNext,
  onNavigate,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onFullscreen,
}: UseImageKeyboardOptions) {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      } else if (e.key === "ArrowLeft" && canNavigatePrev) {
        onNavigate("prev");
      } else if (e.key === "ArrowRight" && canNavigateNext) {
        onNavigate("next");
      } else if (e.key === "+" || e.key === "=") {
        onZoomIn();
      } else if (e.key === "-") {
        onZoomOut();
      } else if (e.key === "0") {
        onResetZoom();
      } else if (e.key === "f" || e.key === "F") {
        onFullscreen();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    open,
    onClose,
    canNavigatePrev,
    canNavigateNext,
    onNavigate,
    onZoomIn,
    onZoomOut,
    onResetZoom,
    onFullscreen,
  ]);
}

